import React, { useMemo } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { FilterFacet } from '@apps/stays/components/filters/FilterFacet';
import { StyledCheckboxV2 } from '@apps/stays/components/filters/StyledCheckboxV2';
import { useTranslation } from '@shared/core';
import { INDEPENDENT_BRAND } from '../../../constants';

type BrandFacetProps = Readonly<{
  title: string;
  brands: ReadonlyArray<{ label: string }>;
  selectedBrands: ReadonlyArray<string>;
  brandCounts: Readonly<Record<string, number>>;
  onBrandToggle: (brand: string) => void;
}>;

export const BrandFacet: React.FC<BrandFacetProps> = ({ title, brands, selectedBrands, brandCounts, onBrandToggle }) => {
  const { tq } = useTranslation('accommodationsConsole');
  const selectedSet = useMemo(() => new Set(selectedBrands), [selectedBrands]);
  return (
    <FilterFacet title={title}>
      <Flex
        flexDirection="column"
        gap={5}
      >
        {brands.map(brand => {
          const displayLabel = brand.label === INDEPENDENT_BRAND ? tq`Independent` : brand.label;
          const count = brandCounts[brand.label] ?? 0;
          return (
            <StyledCheckboxV2
              key={brand.label}
              isChecked={selectedSet.has(brand.label)}
              onChange={() => onBrandToggle(brand.label)}
              id={`brand-${brand.label}`}
              isDisabled={!count}
            >
              <TextV2
                typographyVariant="body1"
                color="mono14"
              >
                {displayLabel}
                {'\u00A0'}
                <TextV2
                  as="span"
                  typographyVariant="body1"
                  color="mono10"
                >
                  ({count})
                </TextV2>
              </TextV2>
            </StyledCheckboxV2>
          );
        })}
      </Flex>
    </FilterFacet>
  );
};
